import { AlertTriangle, Smartphone } from 'lucide-react';
import { useMemo } from 'react';
import AuthStatusLayout from './components/auth/AuthStatusLayout';
import { buildAppOpenUrl } from './lib/authUrls';

const REASON_COPY = {
  auth_unavailable:
    'Email confirmation is temporarily unavailable.',
  invalid_or_expired:
    'This confirmation link is invalid, expired, or has already been used. If you need a fresh confirmation email, request it from the app.',
};

function getReasonCopy(reason) {
  return REASON_COPY[reason] || REASON_COPY.invalid_or_expired;
}

export default function AuthErrorPage() {
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const reason = searchParams.get('reason') || 'invalid_or_expired';

  return (
    <AuthStatusLayout
      tone="neutral"
      title="Confirmation link no longer works"
      body={getReasonCopy(reason)}
      icon={<AlertTriangle size={18} />}
      actions={[
        {
          label: 'Open app',
          href: buildAppOpenUrl(),
          external: true,
          variant: 'ghost',
          icon: <Smartphone size={18} />,
        }
      ]}
    >
    </AuthStatusLayout>
  );
}
